import IconBase from "./IconBase";

// Panels of unequal size, the way a real dashboard lays out: one primary
// column beside two stacked cards. Avoids the generic four-equal-squares grid,
// which is reserved here for Apps.
const DashboardIcon = (props) => (
    <IconBase {...props}>
        <rect x="3" y="3" width="8" height="18" rx="2.5" />
        <rect x="14" y="3" width="7" height="7" rx="2.5" />
        <rect x="14" y="14" width="7" height="7" rx="2.5" />
    </IconBase>
);

export default DashboardIcon;
